<template>
  <div
    class="flex flex-col items-center justify-center px-6 py-10 text-center"
    :class="compact ? 'py-8' : 'py-12'"
  >
    <span
      class="flex items-center justify-center w-14 h-14 mb-4 rounded-2xl bg-gradient-to-br from-primary/15 to-primary/5 text-primary ring-1 ring-primary/15"
    >
      <i class="mdi mdi-bell-check-outline text-[28px]"></i>
    </span>
    <p class="text-sm font-medium text-slate-700 dark:text-slate-200">
      {{ title || t("notifications_empty") }}
    </p>
    <p
      v-if="subtitle"
      class="mt-1 text-xs text-slate-500 dark:text-slate-400 max-w-[16rem] text-center"
      :dir="lang === 'ar' ? 'rtl' : 'ltr'"
    >
      {{ subtitle }}
    </p>
  </div>
</template>

<script setup>
defineProps({
  title: { type: String, default: "" },
  subtitle: { type: String, default: "" },
  compact: { type: Boolean, default: false },
  lang: { type: String, default: "ar" },
  t: { type: Function, default: () => (k) => k },
});
</script>
